module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_8019.c11317b4.png";